// Interfaces
import { AffordableRoom, PrimaryGuest, Term } from "./CreateWaitlist";
import Item from "./ItemInterface";

export interface ContractUsage {
  usageId: string;
  contractId: string;
  contractNumber: string;
  usageType: string;
  type: string;
  usageYear: string;
  year: string;
  startDate: string;
  endDate: string;
  available: string;
  applied: number;
  appliedPoints: number;
  canBorrow?: boolean;
  borrowChecked?: boolean;
  reason?: string[];
  disabled?: boolean;
  refundChecked?: boolean;
  description?: string;
  MaxAllowed?: string;
  usageOrder?: string;
  segmentType: string;
  usageTypeID?: string; 
}

export interface UsageDetail {
  usage: Usage[];
  refundUsage: Usage[];
  refundedNormalUsageTypes?: Usage[];
  refundedHoldUsageTypes?: Usage[];
  refundedForefeitUsageTypes?:Usage[];
  borrowedUsage: Usage[];
  appliedPoints: number;
  totalPointsReturned?: number;
  holdPoints?: number;
  forefeitPoints?: number;
}

export interface Usage {
  contractId: string;
  contractNumber: string;
  type: string;
  year: string;
  applied: number;
  startDate?: string|Date;
  endDate?: string|Date;
  description?: string; 
}

export interface RoomType {
  description: string;
  value?: string;
  name?: string;
}

export interface ReservationDetails {
  resortName: string;
  resortLocation: string;
  resortImage: string;
  roomType: any;
  checkInDate: string|Date;
  checkOutDate: string|Date;
  numOfNights: number;
  numOfGuests: number;
  accessibility: Item[];
  hearingaccessible: boolean;
  pointsRequired: any;
  resortId?: string;
  roomPoolCode?: string;
  marshaRateCode?: string;
  managementCompany?: ManagementCompany;
  checkInDays?:any;
}

export interface WaitListReservationDetails {
  resortName: string;
  resortId?: string;
  resortImage: string;
  resortLocation: string;
  roomType: any;
  roomPoolCode?: string;
  marshaRateCode: string;
  checkInRangeStart: string|Date;
  checkInRangeEnd: string|Date;
  numOfNights: number;
  numOfGuests: number;
  accessibility: Item[];
  hearingaccessible: boolean;
  pointsRequired: number;
  checkInSunday: boolean,
  checkInMonday: boolean;
  checkInTuesday: boolean;
  checkInWednesday: boolean;
  checkInThursday: boolean;
  checkInFriday: boolean;
  checkInSaturday: boolean;
}

export type Preferences = {
  code: string;
  name: string;
  multiselect: boolean;
  options: {
    code: string;
    name: string;
    default?: boolean;
    tswcode: string;
    selected?: boolean;
  }[];
}[];

export interface UsageRequiredByDay {
  originalAmount: number;
  pointAmount: number;
  promotionalOffsets: any[];
  roomDate: string;
};

export interface SuggestedAutoApply {
  days: number;
  points: number;
  segmentId: number;
  segmentName: string;
  segmentType: string;
  usageYearId: number;
};

export interface AutoAdjustUsage {
  remaining: number;
  applied: number;
  maxAllowed: number;
  usageYearId: number;
  usageType: string;
};

export interface AYPResult {
  reservationDetails: ReservationDetails;
  eligibleUsages: ContractUsage[];
  ineligibleUsages: ContractUsage[];
  waitlistUsages : ContractUsage[];
  usageRequiredByDay: UsageRequiredByDay[];
  suggestedAutoApply: SuggestedAutoApply[];
  PromotionIDs: Number[];
}

export interface WaitlistAYPResult {
  waitlistReservationID: number;
  reservationDetails: WaitListReservationDetails;
  eligibleUsages: ContractUsage[];
  ineligibleUsages: ContractUsage[];
  waitlistUsages : ContractUsage[];
  usageRequiredByDay: UsageRequiredByDay[];
  pointAmountMin: number;
  waitlistRooms: WaitlistRooms[];
}

export interface WaitlistRooms {
  roomPoolCode: string;
  rateCode: string[];
  pointAmountMin: number;
  pointAmountMax: number;
  roomType: RoomType;
}

export interface WaitlistSummaryResponse {
  waitlistReservationID: number;
  reservationDetails: WaitListReservationDetails;
  eligibleUsages: ContractUsage[];
  ineligibleUsages: ContractUsage[];
  waitlistUsages : ContractUsage[];
  usageRequiredByDay: UsageRequiredByDay[];
  pointAmountMin: number;
  waitlistRooms: WaitlistRooms[];
  sessionId: string;
  priority: number;
  expirationLeadTime: number;
  affordableRoom: AffordableRoom;
  primaryGuest: PrimaryGuest;
  preferences: Preferences;
  terms: Term[];
}

export interface ManagementCompany {
  nodename: string;
  resourceId: string;
  phone: string;
  name: string;
  url: string;
  imageUrl: string;
  email: string;
  reservationViewFields: string[];
  siteType: string;
}

export enum ManagementCompanyType {
  MVC = "MVC"
}

export enum SiteType {
  MVC = "MVC Collection",
  EXPLORER = "Explorer Collection",
  EXCHANGE = "Exchange Partner Resorts"
}

export enum ReservationViewFields {
  NUMBER_NIGHTS = "number-of-nights",
  NUMBER_GUESTS = "number-of-guests",
  CHECK_IN = "check-in-date",
  CHECK_OUT = "check-out-date",
  GUEST_INFO = "guest-information",
  PRIMARY_GUEST = "primary-guest",
  ADDITIONAL_GUESTS = "additional-guests",
  ADDITIONAL_EMAILS = "additional-emails",
  HOVER_POP_UP = "hover-pop-up"
}

export function showReservationField(resViewField:ReservationViewFields, resDetails: ReservationDetails) {
  //if there are no defined fields, the field is not be limited and should be displyed, but if there are defined fields, it must exist in the field list to display
  let show = true;
  if (
      resDetails
      && resDetails.managementCompany
      && resDetails.managementCompany.reservationViewFields
      && resDetails.managementCompany.reservationViewFields.length > 0
      && !resDetails.managementCompany.reservationViewFields.includes(resViewField)
  ) {
      show = false;
  }
  return show;
}